import { useEffect } from 'react'

import { currentPageParams } from 'scrivito'

import { writeUrlParams } from '@/hooks/useUrlParams'

const VIEW_PARAM = 'view'
const KANBAN_VIEW = 'kanban'
const DEFAULT_VIEW = 'default'

export const useKanbanView = (kanbanViewPresent: boolean) => {
  const view = currentPageParams()[VIEW_PARAM] as string | null
  const active = view === KANBAN_VIEW

  useEffect(() => {
    if (kanbanViewPresent && !view) {
      writeUrlParams({ [VIEW_PARAM]: DEFAULT_VIEW }, true)
    }
  }, [kanbanViewPresent, view])

  const toggle = () => {
    const isKanban = currentPageParams()[VIEW_PARAM] === KANBAN_VIEW
    writeUrlParams({ [VIEW_PARAM]: isKanban ? DEFAULT_VIEW : KANBAN_VIEW })
  }

  return {
    active,
    toggle,
  }
}
